<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-17 14:45:48
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\InternalUse\components\shiftDialog.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-28 14:14:02
-->
<template>
  <v-navigation-drawer
    v-model="drawer"
    width="427"
    right
    :key="curKey"
    @input="onChange"
    temporary
    fixed
    :overlay-opacity="0.1"
  >
    <v-container
      fluid
      class="d-flex flex-column justify-space-around pa-0 fill-height"
    >
      <v-toolbar flat dense class="pr-3" style="width: 100%">
        <v-toolbar-title class="text-subtitle-2">
          <v-list-item-title class="table-subttile text--primary">{{
            curData ? $getCommonLangValue(curData["preferred_name"]) : ""
          }}</v-list-item-title>
          <v-list-item-subtitle class="table-subttile text--secondary">{{
            curData ? curData["roster_date"] : ""
          }}</v-list-item-subtitle>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click.stop="closeDialog"
              color="primary"
              small
            >
              <span class="material-icons-round">close</span>
            </v-btn>
          </template>
          <span>{{
            $t("label_essweb_RosterRecord_slide_adhoc_closeBtnTip")
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        class="pa-0 scroll_content_y"
        :style="{ height: 'calc(100% - 108px)' }"
      >
        <Taber
          :curTab="curTab"
          @change="(tab) => (curTab = tab)"
          :items="taber"
          border
          :height="40"
          special
          contentBackground="fill-height"
          backgroundColor="white"
        >
          <template v-slot:content-1>
            <!-- <v-container  class="scroll_content_y"> -->
            <!-- <v-sheet v-for="(item,index) in shiftList" :key="index"> -->
            <!-- <v-sheet class="d-flex flex-row">
            <span>{{$getCommonLangValue(item.shift_type_name)}}</span>
            <span class="material-icons-round">arrow_right</span>
            </v-sheet>-->
            <v-form
              ref="form3"
              class="px-4 pa-0 py-2"
              lazy-validation
              v-if="shiftList.length > 0 || search != ''"
            >
              <v-row dense>
                <v-col>
                  <v-text-field
                    filled
                    clearable
                    dense
                    color="grey"
                    prepend-inner-icon="search"
                    clear-icon="cancel"
                    single-line
                    hide-details
                    :placeholder="
                      $t('label_essweb_shift_list_shiftNameLabel') +
                      '/' +
                      $t('label_essweb_shift_list_shiftAbbrLabel')
                    "
                    v-model="search"
                    rounded
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-divider v-if="shiftList.length > 0 || search != ''"></v-divider>
            <noContent v-if="shiftList.length == 0" />
            <v-list
              dense
              class="pa-a scroll_content_y scroll_content_x_no"
              nav
              :height="$vuetify.breakpoint.height - 232"
              v-model="curSelect"
            >
              <v-list-item
                v-for="(it, i) in shiftList"
                :style="{
                  backgroundColor: it.color_code,
                  height: '48px',
                }"
                :key="i"
                @click.stop="
                  curSelect = it.uuid;
                  editingShift = it;
                "
                :color="it.color_code"
                class="d-flex text-left pl-0 my-4 pr-1 flex-3 flex-row"
              >
                <!-- :class="curSelect == it.uuid ? 'active-class' : ''" 

                <span
                  class="special-action white--text"
                  v-if="curSelect == it.uuid"
                  :style="{
                    borderRightColor: 'var(--main-color)',
                    borderBottomColor: 'var(--main-color)',
                  }"
                >
                  <span class="material-icons-round">check</span>
                </span>-->
                <span
                  class="material-icons-round primary--text mr-n2 ml-2"
                  v-if="curSelect == it.uuid"
                  >check_circle</span
                >
                <!-- <div
                  class="rounded mr-1"
                  :style="{
                    background: it.color_code,
                    width: '5px',
                    height: '48px',
                  }"
                ></div> -->
                <div
                  class="pl-3 text--primary text-subtitle-2 text-ellipsis-2"
                  style="max-width: 70%"
                >
                  {{ $getCommonLangValue(it.shift_abbr) }}
                </div>
                <div class="ml-auto text--secondary caption">
                  {{ getStartEnd(it) }}
                  <!-- {{ $timeMachine(it.start_utc_time) }}-{{
                    $timeMachine(it.end_utc_time)
                    }}-->
                </div>
                <v-btn
                  icon
                  small
                  class="ml-3"
                  v-if="it.is_allow_override_to_adhoc"
                  :disabled="curSelect != it.uuid"
                  @click="toChangeShift(it)"
                >
                  <span class="material-icons-round">edit</span>
                </v-btn>
              </v-list-item>
            </v-list>
            <!-- </v-sheet> -->
            <!-- </v-container> -->
          </template>
          <template v-slot:content-2>
            <v-form ref="form">
              <v-row dense class="pa-4">
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  v-if="Number(is_allow_leave_remark)"
                >
                  <AutoComplete
                    single-line
                    v-model="leave_type_remark_uuid"
                    small-chips
                    label="label_essweb_RosterRecord_slide_form_leaveRemarkLabel"
                    deletable-chips
                    chips
                    :items="LeaveType"
                    item-text="leave_type_name"
                    item-value="uuid"
                  >
                  </AutoComplete>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  v-if="Number(is_allow_site)"
                >
                  <AutoComplete
                    v-model="site_uuid"
                    small-chips
                    label="label_essweb_shift_form_siteNameLabel"
                    chips
                    deletable-chips
                    :items="siteList"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                    <template v-slot:item.subtitle="{ data }">
                      {{ $getCommonLangValue(data.item.f1) }}
                    </template>
                  </AutoComplete>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  v-if="Number(is_allow_cost_center)"
                >
                  <AutoComplete
                    v-model="cost_center_uuid"
                    small-chips
                    chips
                    label="label_essweb_ClaimRecord_form_dialog_costCentreLabel"
                    deletable-chips
                    :items="costCenter"
                    item-text="view_fields"
                    item-value="value_field"
                  >
                  </AutoComplete>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  v-if="Number(is_allow_temp_supervisor)"
                >
                  <AutoComplete
                    v-model="selectStaff"
                    :items="allStaff"
                    label="label_essweb_RosterRecord_dialog_interimSupervisorLabel"
                    chips
                    :filter="$staffFilter"
                    multiple
                    avatar
                    two-line
                    simple
                    item-text="staff_code"
                    item-value="staff_id"
                  >
                    <template v-slot:selection.avatar="{ data }">
                      <StaffAvatar
                        left
                        :isTemp="data.item.is_temp"
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                      />
                    </template>
                    <template v-slot:selection="{ data }">
                      {{ $getCommonLangValue(data.item.preferred_name) }}
                    </template>
                    <template v-slot:item.avatar="{ data }">
                      <StaffAvatar
                        size="36"
                        :isTemp="data.item.is_temp"
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                    /></template>
                    <template v-slot:item.title="{ data }">
                      <span class="text-body-2"
                        >{{ $getCommonLangValue(data.item.preferred_name) }}
                        <span class="text--secondary text-caption-xs">{{
                          data.item.staff_code
                        }}</span></span
                      ></template
                    >
                    <template v-slot:item.subtitle="{ data }"
                      >{{ $getCommonLangValue(data.item.job_post_name) }}
                    </template>
                  </AutoComplete>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  v-if="Number(manual_is_allow_select_holiday)"
                >
                  <v-sheet class="text--secondary">{{
                    $t("label_ess_web_shift_dialog_slide_publicHolidayLabel")
                  }}</v-sheet>
                  <AutoComplete
                    label="label_ess_web_shift_dialog_slide_publicHolidayLabel"
                    v-model="curHoliday"
                    small-chips
                    chips
                    deletable-chips
                    :items="HolidayOff"
                    item-text="holiday_name"
                    item-value="uuid"
                  >
                    <template v-slot:selection="{ data }">
                      {{ $getCommonLangValue(data.item.holiday_name) }}
                    </template>
                    <template v-slot:item.title="{ data }">
                      <span class="text-body-2 d-flex align-center">
                        <i
                          class="material-icons-round red--text mr-1"
                          v-if="Number(data.item.is_old)"
                          >error_outline</i
                        >
                        {{ $getCommonLangValue(data.item.holiday_name) }}</span
                      ></template
                    >
                    <template v-slot:item.subtitle="{ data }">
                      {{ $getCommonLangValue(data.item.holiday_abbr) }}
                    </template>
                  </AutoComplete>
                  <v-menu
                    v-model="showHoliday"
                    top
                    v-if="HolidayOff.length > 0 && false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item
                        :style="{
                          height: '48px',
                          background:
                            curHoliday === null ? '#dadada' : '#eeeef0',
                        }"
                        @click.stop="
                          showHoliday = true;
                          curHoliday = -1;
                        "
                        class="
                          d-flex
                          text-left
                          pl-0
                          my-2
                          pr-1
                          flex-3 flex-row
                          rounded
                        "
                      >
                        <!-- :class="curHoliday !== null ? 'active-class' : ''"
                    <span
                      class="special-action white--text"
                      v-if="curHoliday !== null"
                      :style="{
                        borderRightColor: 'var(--main-color)',
                        borderBottomColor: 'var(--main-color)',
                      }"
                    >
                      <span class="material-icons-round">check</span>
                    </span> -->
                        <div
                          class="rounded mr-1"
                          :style="{
                            background: 'grey',
                            width: '5px',
                            height: '48px',
                          }"
                        ></div>
                        <div
                          class="text--primary text-body-2 text-ellipsis-2"
                          style="max-width: 70%"
                        >
                          {{ $getCommonLangValue(holiday_name) }}
                        </div>
                        <v-spacer> </v-spacer>
                        <span class="material-icons-round">{{
                          showHoliday ? "arrow_drop_up" : "arrow_drop_down"
                        }}</span>
                      </v-list-item>
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="(item, index) in HolidayOff"
                        :key="index"
                        @click="curHoliday = item.uuid"
                      >
                        <v-list-item-title>
                          {{
                            $getCommonLangValue(item.holiday_name)
                          }}</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  cols="12"
                  v-if="Number(is_allow_remark)"
                >
                  <v-sheet class="text--secondary">{{
                    $t("label_essweb_RosterRecord_slide_remarkLabel")
                  }}</v-sheet>
                  <v-textarea
                    rows="5"
                    no-resize
                    maxlength="500"
                    filled
                    single-line
                    dense
                    counter="500"
                    v-model="remarks"
                    name="input-7-4"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </template>
        </Taber>
      </v-container>
      <v-spacer></v-spacer>
      <v-sheet
        height="60"
        class="
          align-center
          text-center
          flex-row
          d-flex
          justify-center
          max-width
        "
        style="border-top: 1px solid var(--main-border-color)"
      >
        <v-btn
          color="gery"
          rounded
          text
          height="32"
          class="pl-7 pr-7 text-capitalize mr-2 text-body-1"
          @click="closeDialog"
          >{{ $t("label_essweb_RosterRecord_slide_form_cancelLabel") }}</v-btn
        >
        <v-btn
          color="primary"
          rounded
          height="32"
          :loading="loading"
          class="pl-7 pr-7 text-capitalize text-body-1"
          :disabled="!curSelect || loading || isLoading"
          @click="toSubmit"
          >{{
            $t("label_essweb_RosterRecord_slide_form_submitBtnLabel")
          }}</v-btn
        >
      </v-sheet>
    </v-container>
    <!-- !!!!!!!!!!!!!!!!!!!!!! -->
    <template>
      <v-navigation-drawer
        width="427"
        right
        temporary
        v-model="showEditShift"
        fixed
        :overlay-opacity="0.1"
      >
        <v-container
          fluid
          class="d-flex flex-column justify-space-around pa-0 fill-height"
        >
          <v-toolbar flat dense class="pr-3" style="width: 100%">
            <v-toolbar-title class="text-subtitle-2">
              <v-list-item-title class="table-subttile text--primary">{{
                $t("label_essweb_RosterRecord_slide_adhoc_title")
              }}</v-list-item-title>
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  @click.stop="showEditShift = false"
                  color="primary"
                  small
                >
                  <span class="material-icons-round">close</span>
                </v-btn>
              </template>
              <span>{{
                $t("label_essweb_RosterRecord_slide_adhoc_closeBtnTip")
              }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-divider class="max-width"></v-divider>
          <v-container
            fluid
            class="pa-4 scroll_content_y"
            :style="{ height: 'calc(100% - 109px)' }"
          >
            <v-form lazy-validation ref="form2">
              <v-row no-gutters>
                <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                  <v-text-field
                    single-line
                    filled
                    :disabled="true"
                    v-model="shiftData.shift_abbr"
                    placeholder="shift"
                    dense
                  ></v-text-field>
                  <!-- 2020-09-03改为非国际化 -->
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" cols="12">{{
                  $t("label_essweb_RosterRecord_slide_adhoc_abbrLabel")
                }}</v-col>
                <v-col md="3">
                  <v-text-field
                    single-line
                    filled
                    v-model="shiftData.prefix_shift_abbr"
                    :placeholder="
                      $t('label_essweb_RosterRecord_slide_adhoc_prefixLabel')
                    "
                    dense
                  ></v-text-field>
                </v-col>
                <v-col md="1" class="d-flex justify-center align-top pt-3"
                  >-</v-col
                >
                <v-col md="3">
                  <v-text-field
                    single-line
                    filled
                    :disabled="true"
                    v-model="shiftData.shift_abbr"
                    :placeholder="
                      $t('label_essweb_RosterRecord_slide_adhoc_abbrLabel')
                    "
                    dense
                  ></v-text-field>
                  <!-- 2020-09-03改为非国际化 -->
                </v-col>
                <v-col md="1" class="d-flex justify-center align-top pt-3"
                  >-</v-col
                >
                <v-col md="3">
                  <v-text-field
                    single-line
                    filled
                    v-model="shiftData.suffix_shift_abbr"
                    :placeholder="
                      $t('label_essweb_RosterRecord_slide_adhoc_suffixLabel')
                    "
                    dense
                  ></v-text-field>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                  <v-container
                    class="mt-4 pa-4"
                    style="border: 1px solid var(--main-border-color)"
                    v-for="(item, index) in shiftData.event_list"
                    :key="`event_list${index}`"
                  >
                    <span class="text-subtitle-2">
                      {{ $getCommonLangValue(item.event_business_name) }}
                    </span>
                    <v-row>
                      <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                        <TimePicker
                          isRequire
                          :value="item.start_utc_time"
                          :defaultTime="item.start_utc_time"
                          :max="item.end_utc_time"
                          :label="
                            $t(
                              'label_essweb_RosterRecord_slide_adhoc_startTimeLabel'
                            )
                          "
                          @change="
                            (time) => {
                              item.start_utc_time = time;
                            }
                          "
                        />
                      </v-col>
                      <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                        <TimePicker
                          isRequire
                          isEnd
                          showDay
                          :min="item.start_utc_time"
                          :value="item.end_utc_time"
                          :defaultTime="item.end_utc_time"
                          :label="
                            $t(
                              'label_essweb_RosterRecord_slide_adhoc_endTimeLabel'
                            )
                          "
                          @change="
                            (time) => {
                              item.end_utc_time = time;
                            }
                          "
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-spacer></v-spacer>
          <v-sheet
            height="60"
            class="
              align-center
              text-center
              flex-row
              d-flex
              justify-center
              max-width
            "
            style="border-top: 1px solid var(--main-border-color)"
          >
            <v-btn
              color="gery"
              rounded
              text
              height="32"
              class="pl-7 pr-7 text-capitalize mr-2"
              @click="showEditShift = false"
              >{{
                $t("label_essweb_RosterRecord_slide_adhoc_cancelLabel")
              }}</v-btn
            >
            <v-btn
              color="primary"
              rounded
              height="32"
              class="pl-7 pr-7 text-capitalize"
              @click="toShift"
              >{{
                $t("label_essweb_RosterRecord_slide_adhoc_submitBtnLabel")
              }}</v-btn
            >
          </v-sheet>
        </v-container>
      </v-navigation-drawer>
    </template>
    <!-- !!!!!!!!!!!!!!!!!! -->
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";

import dayjs from "dayjs";
export default {
  name: "RosterShiftDialog",
  props: {
    show: { default: false, type: Boolean },
    curData: { deffult: null, type: Object },
  },
  computed: {
    ...mapGetters(["companyLang", "isLoading"]),
    curDate() {
      return this.curData["roster_date"];
    },
    LeaveType() {
      return this.$getSelectTrans(this.LeaveTypeData, "leave_type_name");
    },
    costCenter() {
      return this.$getSelectTrans(this.costCenterData, "view_fields");
    },
    siteList() {
      return this.$getSelectTrans(this.siteListData, "view_fields");
    },
    HolidayOff() {
      return this.$getSelectTrans(this.HolidayOffData, "holiday_name");
    },
    curShift() {
      const that = this;
      var curshift = null;
      if (this.curData !== null && this.curDate !== "") {
        let curTemp = [];
        if (this.curData.rosters) {
          curTemp = this.curData.rosters.filter(
            (ele) =>
              dayjs(ele.roster_utc_datetime).format("YYYY-MM-DD") ===
              this.curDate
          );
        } else {
          this.curData.rosters = [];
        }

        this.shiftLen = curTemp.length;
        this.curAllShift = curTemp;
        if (curTemp.length > 0) {
          curshift = curTemp[0];
          this.curSelect = curshift["shift_uuid"];
        }
      }
      return curshift;
    },
    shiftList() {
      const that = this;
      if (!this.search) return that.shiftListData;
      if (this.search.trim() === "") return that.shiftListData;
      let arr = [];
      that.shiftListData.map((item) => {
        if (
          that
            .$getCommonLangValue(item.shift_name)
            .toUpperCase()
            .indexOf(that.search.toString().toUpperCase()) > -1 ||
          that
            .$getCommonLangValue(item.shift_abbr)
            .toUpperCase()
            .indexOf(that.search.toString().toUpperCase()) > -1
        )
          arr.push(item);
      });
      return arr;
    },
    drawer: {
      get() {
        return this.show;
      },
      set(val) {
        return val;
      },
    },
    holiday_name() {
      if (this.curHoliday === null)
        return this.$t("label_ess_web_shift_dialog_slide_publicHolidayLabel");
      else
        return this.HolidayOff.find(
          (ele) => ele.uuid.toString() === this.curHoliday.toString()
        )["holiday_name"];
    },
  },
  watch: {
    showEditShift(val) {
      if (!val) {
        // if (this.$refs["form2"]) this.$refs["form2"].reset();
        this.shiftData = {
          uuid: "",
          shift_abbr: "",
          start_utc_time: 0,
          end_utc_time: 0,
          prefix_shift_abbr: "",
          suffix_shift_abbr: "",
          event_list: [],
        };
      } else {
        this.getShiftDetail(this.curSelect);
      }
    },
    editingShift(val) {
      if (val) {
        if (val.shift_adhoc == null) {
          if (val.is_allow_override_to_adhoc) {
            this.getShiftDetail(this.curSelect);
          }
          this.shiftData = val;
        } else {
          this.shiftData = val.shift_adhoc;
        }
      }
    },
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.curSelect = null;
        this.showHoliday = false;
        this.curHoliday = null;
        this.curTab = "tab-1";
        this.shiftListData = [];
        this.search = "";
        this.curKey = Math.random() * 1000000000;
      }
    },
    curSelect(val) {
      if (val) {
        // this.getShiftDetail(val);
      }
    },
    curData(val) {
      if (val) {
        this.getShiftList(val.staff_uuid);
        this.getHolidayOff(val.staff_uuid, val["roster_date"]);
        this.getRemarkDetail(val.staff_uuid, val["roster_date"]);
        const that = this;
        // var curshift = null;
        // if (this.curData !== null && this.curDate !== "") {
        //   let curTemp = [];
        //   if (this.curData.rosters) {
        //     curTemp = this.curData.rosters.filter(
        //       (ele) =>
        //         dayjs(ele.roster_utc_datetime).format("YYYY-MM-DD") ===
        //         this.curDate
        //     );
        //   } else {
        //     this.curData.rosters = [];
        //   }
        //   this.shiftLen = curTemp.length;
        //   this.curAllShift = curTemp;
        //   if (curTemp.length > 0) {
        //     curshift = curTemp[0];
        this.curSelect = val["official_shift_uuid"];
        //   }
        // }
      }
    },
  },
  mounted() {
    this.getLeaveType();
    this.getSiteList();
    this.getCostCenter();
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
    // this.shiftData.shift_name = this.$getCommonLangKey(this.companyLang);
    // this.shiftData.shift_description = this.$getCommonLangKey(this.companyLang);
    // this.shiftData.shift_abbr = this.$getCommonLangKey(this.companyLang);
  },
  data() {
    return {
      showHoliday: false,
      curHoliday: null,
      shiftListData: [],
      allStaff: [],
      loading: false,
      curSelect: null,
      selectStaff: [],
      remarks: "",
      search: "",
      curKey: "123",
      LeaveTypeData: [],
      HolidayOffData: [],
      costCenterData: [],
      siteListData: [],
      showEditShift: false,
      leave_type_remark_uuid: "",
      site_uuid: "",
      cost_center_uuid: "",
      is_allow_leave_remark: 0,
      manual_is_allow_select_holiday: 0,
      is_allow_site: 0,
      is_allow_cost_center: 0,
      is_allow_temp_supervisor: 0,
      is_allow_remark: 0,
      editingShift: null,
      isRefresh: 0,
      shiftData: {
        uuid: "",
        shift_abbr: "",
        start_utc_time: 0,
        end_utc_time: 0,
        prefix_shift_abbr: "",
        suffix_shift_abbr: "",
        event_list: [],
      },
      curTab: "tab-1",
      curStaff: null,
      taber: [
        "label_essweb_RosterRecord_slide_tab_shiftLabel",
        "label_essweb_RosterRecord_slide_tab_moreLabel",
      ],
    };
  },
  methods: {
    removeStaff: function (item) {
      this.selectStaff = this.selectStaff.filter(
        (ele) => Number(ele) !== Number(item.staff_id)
      );
    },
    getHolidayOff: function (staff, date) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/roster/get-day-off/",
        data: {
          staff_uuid: staff,
          utc_att_date: this.$getTimeValue(date),
        },
        type: "client",
      }).then((res) => {
        that.HolidayOffData = res.data;
      });
    },
    getSiteList: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_site_select",

        global: false,
      }).then((res) => {
        that.siteListData = res.data;
      });
    },
    getCostCenter: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_cost_center_select",

        global: false,
      }).then((res) => {
        that.costCenterData = res.data;
      });
    },
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",

        global: false,
      }).then((res) => {
        that.LeaveTypeData = res.data;
      });
    },
    onChange: function (val) {
      this.$emit("onChange", val);
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toChangeShift: function (obj) {
      // console.log(obj);
      if (obj.shift_adhoc == null) {
        // this.getShiftDetail(this.curSelect);
      } else {
        this.shiftData = obj.shift_adhoc;
      }
      this.showEditShift = true;
    },
    toShift: function () {
      const that = this;
      that.showEditShift = false;
      this.shiftListData.map((item) => {
        if (item.uuid == that.shiftData["uuid"]) {
          item["shift_adhoc"] = that.shiftData;
        }
      });
      this.shiftData = {
        uuid: "",
        shift_abbr: "",
        start_utc_time: 0,
        end_utc_time: 0,
        prefix_shift_abbr: "",
        suffix_shift_abbr: "",
        event_list: [],
      };
    },
    toSubmit: function () {
      const that = this;
      let data = {};
      // 提交排班信息
      if (this.curTab == "tab-1") {
        if (!this.curSelect) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_errNoticeTitle"),
            text: this.$t(
              "message_essweb_rosterFormRecord_form_selectShiftLabel"
            ),
            type: "error",
          });
          return false;
        }
        that.loading = true;
        data = {
          staff_uuid: this.curStaff,
          utc_att_date: this.$getTimeValue(this.curData["roster_date"]),
          shift_uuid: this.curSelect,
        };
        let currentShift = null;
        this.shiftListData.map((it) => {
          if (it.uuid == that.curSelect) {
            currentShift = it;
          }
        });
        //是否灵活班
        if (
          currentShift != null &&
          currentShift["shift_adhoc"] !== undefined &&
          currentShift["shift_adhoc"] != null
        ) {
          currentShift["shift_adhoc"]["event_list"].map((item) => {
            item["total_minutes"] =
              Number(item["end_utc_time"]) - Number(item["start_utc_time"]);
            item["event_uuid"] = item["uuid"];
          });
          data["prefix_shift_abbr"] =
            currentShift["shift_adhoc"]["prefix_shift_abbr"];
          data["suffix_shift_abbr"] =
            currentShift["shift_adhoc"]["suffix_shift_abbr"];
          data["event_list"] = currentShift["shift_adhoc"]["event_list"];
        }
      }
      // 提交
      if (this.curTab == "tab-2") {
        that.loading = true;

        data = {
          staff_uuid: this.curStaff,
          utc_att_date: this.$getTimeValue(this.curData["roster_date"]),
          leave_type_remark_uuid: that.leave_type_remark_uuid
            ? that.leave_type_remark_uuid
            : "",
          site_uuid: that.site_uuid ? that.site_uuid : "",
          cost_center_uuid: that.cost_center_uuid ? that.cost_center_uuid : "",
          remarks: this.remarks,
        };
        //临时主管
        if (this.selectStaff.length) {
          data["temp_supervisor"] = this.selectStaff.join(",");
        }
        // 设置假期
        if (this.curHoliday !== null) {
          data["holiday_uuid"] = this.curHoliday;
        }
      }

      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/update-roster/",
        data: data,
        global: false,
      })
        .then((res) => {
          that.$emit("onSubmit", {
            shift: that.curSelect,
            leave_type_remark_uuid: that.leave_type_remark_uuid
              ? that.leave_type_remark_uuid
              : "",
            site_uuid: that.site_uuid ? that.site_uuid : "",
            cost_center_uuid: that.cost_center_uuid
              ? that.cost_center_uuid
              : "",
            remarks: that.remarks,
          });
          that.$showMessage({
            text: that.$t(
              "message_essweb_rosterFormRecord_form_updateRosterShiftSuccessLabel"
            ),
            type: "success",
          });
          that.loading = false;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    getStartEnd: function (obj) {
      let text = "";
      if (obj["shift_adhoc"] != undefined && obj["shift_adhoc"] != null) {
        let min = 0;
        let max = 0;
        if (obj["shift_adhoc"]["event_list"].length > 0) {
          min = Number(obj["shift_adhoc"]["event_list"][0]["start_utc_time"]);
          max = Number(obj["shift_adhoc"]["event_list"][0]["end_utc_time"]);
        }
        obj["shift_adhoc"]["event_list"].map((item) => {
          if (Number(item.start_utc_time) < min) {
            min = Number(item.start_utc_time);
          }
          if (Number(item.end_utc_time) < max) {
            max = Number(item.end_utc_time);
          }
        });
        text = this.$timeMachine(min) + " - " + this.$timeMachine(max);
      } else {
        text =
          this.$timeMachine(obj.start_utc_time) +
          " - " +
          this.$timeMachine(obj.end_utc_time);
      }
      return text;
    },
    getShiftList: function (staff) {
      const that = this;
      this.curStaff = staff;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/shift-group/",
        data: {
          staff_uuid: staff,
          utc_att_date: this.$getTimeValue(this.curData["roster_date"]),
        },
        global: false,
      }).then((res) => {
        res.data.map((item) => {
          item["shift_adhoc"] = null;
        });
        that.shiftListData = res.data;
        that.isRefresh = Math.random() * 10000000;
      });
    },
    getRemarkDetail: function (staff, date) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-att-info/",
        data: {
          staff_uuid: staff,
          utc_att_date: this.$getTimeValue(date),
        },
        global: false,
      }).then((res) => {
        that.leave_type_remark_uuid = res.data.leave_type_remark_uuid;
        that.site_uuid = res.data.site_uuid;
        that.cost_center_uuid = res.data.cost_center_uuid;
        that.selectStaff = res.data.temp_supervisor;
        that.remarks = res.data.remarks;
        that.curHoliday = res.data.holiday_uuid ? res.data.holiday_uuid : null;
        that.manual_is_allow_select_holiday = Number(
          res.data.manual_is_allow_select_holiday
        );
        that.is_allow_leave_remark = Number(res.data.is_allow_leave_remark);
        that.is_allow_site = Number(res.data.is_allow_site);
        that.is_allow_cost_center = Number(res.data.is_allow_cost_center);
        that.is_allow_temp_supervisor = Number(
          res.data.is_allow_temp_supervisor
        );
        that.is_allow_remark = Number(res.data.is_allow_remark);
      });
    },
    getShiftDetail: function (uuid) {
      const that = this;
      // if (this.$refs["form2"]) this.$refs["form2"].reset();
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_record",
        url: "/roster/get-shift-info/",
        data: {
          shift_uuid: uuid,
        },
        global: false,
      }).then((res) => {
        // 2020-09-03修改为非国际化
        // res.data["shift_abbr_save"] = res.data.shift_abbr;
        // res.data.shift_abbr = that.$transOnLineCommonLangKey(
        //   that.companyLang,
        //   res.data.shift_abbr
        // );

        that.shiftData = {
          uuid: res.data.uuid,
          shift_abbr: res.data.shift_abbr,
          prefix_shift_abbr: res.data.prefix_shift_abbr,
          suffix_shift_abbr: res.data.suffix_shift_abbr,
          event_list: [],
        };
        res.data.event_list.map((item) => {
          that.shiftData.event_list.push({
            uuid: item.uuid,
            event_business_name: item.event_business_name,
            end_utc_time: item.end_utc_time,
            start_utc_time: item.start_utc_time,
          });
        });
        // console.log(that.shiftData);
      });
    },
  },
};
</script>

<style scoped>
.special-action {
  position: absolute;
  width: 20px;
  height: 20px;
  /* border-top-left-radius: 40px; */
  background: transparent;
  bottom: -1px;
  box-sizing: border-box;
  right: -1px;
  border-bottom-right-radius: 5px;
  border: 10px solid;
  border-left-color: transparent;
  border-top-color: transparent;
  border-right: 10px solid;
  border-bottom: 10px solid;
}
.special-action > .material-icons-round {
  color: white;
  font-size: 16px;
  position: absolute;
  z-index: 3;
  margin-top: -5px;
  margin-left: -8px;
}
.active-class {
  border-width: 2px !important;
  box-sizing: border-box;
  border-style: solid !important;
  border-color: var(--main-color) !important;
}
</style>
